class Globals {

    public static COMPONENT_TRANSITION_TIME = 200;
    public static COMPONENT_ANIMATION_TIME = 800;
    public static COMPONENT_HIDE_SHOW_TRANSITION_TIME = 300;
    public static COMPONENT_HIDE_OPACITY = 0.06;
    public static COMPONENT_DATA_KEY_ATTRIBUTE = 'data-proteic-key';
    public static LEGEND_DATA_KEY_ATTRIBUTE = 'data-proteic-legend-key';
    public static LEGEND_HIDE_OPACITY = 0.3;
    public static BREAKPOINT = 768;
    public static ASPECT_RATIO = 0.7;
    public static SELECTOR_SERIE = 'proteic-serie';
    public static SELECTOR_ELEMENT = 'proteic-element';  
    public static DRAW_INTERVAL = 500;
}

export default Globals;



// WEBPACK FOOTER //
// ./src/Globals.ts